import React from 'react';
import { useFormikContext } from 'formik';

import { Flex } from 'shared/components/display';
import FormButton from 'shared/components/FormButton';
import FormPromptButton from 'shared/components/molecules/FormPromptButton/FormPromptButton';

import { SUBMISSION_COPY } from 'shared/config/copy';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import COLORS from 'shared/styles/colors';

import { SubmissionFormState } from '../../SubmissionForm/types';

import styles from './styles';

interface Props {
  isSubmitted: boolean;
  primaryOnClick: any;
  secondaryOnClick: any;
  onConfirm: (values: SubmissionFormState) => void;
  loadingUpdatePublishSubmission?: boolean;
  loadingUpdateDraftSubmission?: boolean;
}

const SubmissionFormButtons: React.FC<Props> = ({
  isSubmitted,
  primaryOnClick,
  secondaryOnClick,
  onConfirm,
  loadingUpdatePublishSubmission,
  loadingUpdateDraftSubmission,
}) => {
  const { dirty } = useFormikContext<SubmissionFormState>();
  return (
    <Flex css={styles} className="submission-form-buttons">
      <FormButton<SubmissionFormState>
        type="button"
        variant={BUTTON_VARIANTS.SECONDARY}
        className="submission-form-buttons__button"
        onClick={secondaryOnClick}
        loading={loadingUpdateDraftSubmission}
        disabled={loadingUpdatePublishSubmission}
        loaderColor={COLORS.PRIMARY700}
        dataCy="submission-form__save-draft-btn"
      >
        {isSubmitted ? 'Cancel' : SUBMISSION_COPY.BUTTON_SAVE_SUBMISSION_DRAFT}
      </FormButton>
      <FormPromptButton<SubmissionFormState>
        className="submission-form-buttons__submit-button"
        onConfirm={onConfirm}
        onClick={primaryOnClick}
        loading={loadingUpdatePublishSubmission}
        disabled={loadingUpdateDraftSubmission || (isSubmitted && !dirty)}
        buttonText={
          isSubmitted ? SUBMISSION_COPY.BUTTON_SAVE_SUBMISSION_CHANGES : SUBMISSION_COPY.BUTTON_SUBMIT_SUBMISSION
        }
        text={SUBMISSION_COPY.PROMPT_SUBMIT_SUBMISSION}
        validate
      />
    </Flex>
  );
};

export default SubmissionFormButtons;
